import { Injectable } from '@angular/core';
import { Plugins } from '@capacitor/core';

const { Storage } = Plugins;

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  async setString(key: string, value: string) {
    await Storage.set({ key, value });
  }

  async getString(key: string): Promise<{ value: any }> {
    return (await Storage.get({ key }));
  }

  async setObject(key: string, value: any) {
    await Storage.set({ key, value: JSON.stringify(value) });
  }

  async getObject(key: string): Promise<any> {
    const ret = await Storage.get({ key });
    
    if (!ret.value || ret.value === 'undefined' || ret.value === 'null') {
      return null; 
    }
    
    try {
      return JSON.parse(ret.value);
    } catch (e) {
      console.error(`Error parseando JSON en la clave "${key}":`, e);
      return null;
    }
  }


  async removeItem(key: string) {
    await Storage.remove({ key });
  }

  async clear() {
    await Storage.clear();
  }
}